import './Checkbox.scss';
import React, { useEffect, useState } from 'react';

interface CheckboxProps {
  onClick: Function;
  disabled?: boolean;
  label?: string;
  isChecked?: boolean;
}
const Checkbox = ({
  onClick,
  label,
  disabled = false,
  isChecked = false
}: CheckboxProps) => {
  const [checked, setChecked] = useState(isChecked);
  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <label
        className="pure-material-checkbox"
        onClick={(e: any) => {
          if (disabled) return;
          e.preventDefault();
          onClick();
        }}
      >
        <input
          type="checkbox"
          disabled={disabled}
          checked={checked}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
        />
        <span></span>
      </label>
      <span style={{ marginRight: '0.5rem' }}>{label}</span>
    </div>
  );
};

export default Checkbox;
